import * as Sentry from '@sentry/sveltekit';
import { handleErrorWithSentry } from '@sentry/sveltekit';
import { browser } from '$app/environment';

if (browser && import.meta.env.VITE_SENTRY_DSN) {
	// Session Replay is intentionally omitted here: it added ~126KB (mostly
	// unused) to every page load. Core error tracking only.
	Sentry.init({
		dsn: import.meta.env.VITE_SENTRY_DSN,
		environment: import.meta.env.VITE_NODE_ENV ?? 'production',
		tracesSampleRate: 1.0,
	});
}

export const handleError = handleErrorWithSentry();
